import React from "react";
import { connect } from "react-redux";
import T from "prop-types";
import { form, Form as AppForm, Select } from "MODULES/shared/components/Forms";
import { Field } from "redux-form";
import { PAID, REVERSED } from "MODULES/Commissions/constants";
import { Button } from "react-bootstrap";
import * as actions from "../../actions";

const FORM_NAME = "updateCommissionForm";

const statusOptions = [
  { value: "paid", text: "Commission Paid" },
  { value: "bad_debt", text: "Bad Debt" },
  { value: "reversed", text: "Reversed" }
];

class UpdateStatusForm extends React.Component {
  state = {
    status: "paid"
  };

  handleSelectChange = e => {
    this.setState({ status: e.target.value });
  };

  render() {
    const { commission, close } = this.props;

    return (
      <div>
        <AppForm {...this.props}>
          <AppForm.Body>
            <label className="control-label" htmlFor="status">
              Status
            </label>
            <Field
              name="status"
              component={Select}
              options={statusOptions.filter(
                val =>
                  (commission.adjustment_type === "neg_depreciation" ||
                    (val.value !== "paid" && !commission.invoice_paid_date) ||
                    commission.invoice_paid_date) &&
                  ((commission.status === PAID && val.value === REVERSED) ||
                    val.value !== REVERSED)
              )}
            />
          </AppForm.Body>
          <AppForm.Footer>
            <Button onClick={close}>Cancel</Button>
            <Button type="submit" bsStyle="primary">
              Save
            </Button>
          </AppForm.Footer>
        </AppForm>
      </div>
    );
  }
}

UpdateStatusForm.propTypes = {
  commission: T.shape({
    id: T.number
  }).isRequired,
  close: T.func.isRequired,
  errorMessages: T.shape({}),
  submitFailed: T.bool,
  update: T.func.isRequired
};

export default connect(undefined, (dispatch, ownProps) => ({
  onSubmit: data => dispatch(actions.update(ownProps.commission.id, data))
}))(
  form({
    form: FORM_NAME
  })(UpdateStatusForm)
);



// WEBPACK FOOTER //
// ./app/modules/Commissions/components/Search/UpdateStatusForm.jsx